import React from 'react'
import { getMyRun } from '../../api/async/participants/index'
import { zeroPad } from '../../utils/index'
import { Loader } from '../Loader'
import { RaceStatPrenstation } from './presentation'

class RaceStat extends React.Component {
  state = { loading: true, numberOfRun: 0 }
  componentDidMount() {
    getMyRun().then(res => {
      const runs = res.data
        .filter(
          each =>
            each.status === 'approve' &&
            !each.participant.race_detail.race.is_walk
        )
        .reduce(
          (result, current) => {
            result.distance += parseFloat(current.distance)
            result.time += parseFloat(current.time)
            result.numberOfRun += 1
            return result
          },
          { distance: 0, time: 0, numberOfRun: 0 }
        )
      this.setState({ numberOfRun: runs.numberOfRun })
      this.setState({ distance: runs.distance })
      this.setState({ time: runs.time })
      this.setState({ loading: false })
    })
  }

  calCulatePace = () => {
    const basePace = this.state.time / this.state.distance || 0
    const pace = Math.floor(basePace / 1) + (basePace % 1) * 0.6
    return pace.toFixed(2).replace('.', '"')
  }
  formatTime = () =>
    `${zeroPad(Math.floor(this.state.time / 60), 2)}:${zeroPad(
      parseInt(this.state.time % 60),
      2
    )}`
  render() {
    return this.state.loading ? (
      <Loader />
    ) : (
      <React.Fragment>
        <RaceStatPrenstation
          distance={this.state.distance}
          time={this.formatTime()}
          pace={this.calCulatePace()}
          numberOfRun={this.state.numberOfRun}
        />
      </React.Fragment>
    )
  }
}

export default RaceStat



// WEBPACK FOOTER //
// /opt/build/repo/src/components/RaceStat/index.js